(function(){
	"use strict";
	angular.module("josdaviApp").run(appRun);
	appRun.$inject=["$rootScope", "JValidator"];

	function appRun($rootScope, JValidator) {
		$rootScope.$jValidator = JValidator;
	}

})();